/** True on phones and tablets (a finger, not a mouse): they have a camera to open; computers get a file drop zone. */
export function isTouchDevice() {
  try {
    return window.matchMedia("(pointer: coarse)").matches;
  } catch {
    return false;
  }
}
